import { Button, CircularProgress } from '@mui/material';

const LoadingButton = ({
  loading,
  onClick,
  children,
  type,
  style,
  className,
  startIcon
}) => {
  return (
    <Button
      sx={{
        '&.Mui-disabled': {
          opacity: '1',
          color: '#C0C0C0',
          background: '#D9D9D9',
        },
        ...style,
      }}
      onClick={onClick}
      type={type}
      className={className}
      startIcon={startIcon}
      disabled={loading}
    >
      {children}
      {loading && <CircularProgress sx={{ ml: 1 }} size={20} color='inherit' />}
    </Button>
  );
};

export default LoadingButton;
